export default "__VITE_ASSET__CE$4p_OL__"